import _default from './Dropdown';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Dropdown/index.js
// module id = 474
// module chunks = 0